<!-- Componente que representa un mensaje en el chat -->
<template>
  <div :class="user === email ? 'mainn2' : 'mainn'">
    <!-- Foto de perfil -->
    <div class="profile-photo">
      <img class="profile-photo-img" :src="userProfilePhoto">
    </div>

    <!-- Mensaje (texto) -->
    <div v-if="!isFile(message)" class="text-message">
      <p>
        {{ userFormatted }}: {{ message }}
      </p>
    </div>

    <!-- Mensaje (imagen) -->
    <div v-else-if="isFile(message) && message.startsWith('data:image')" class="text-message">
      <img :src="message" alt="Imagen enviada" style="max-width: 100%; max-height: 200px;">
    </div>

    <!-- Pdf -->
    <div v-else-if="isFile(message) && message.startsWith('data:application/pdf')" class="text-message">
      <embed :src="message" type="application/pdf" width="100%" height="200px">
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageChat',
  props: {
    message: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    email() {
      return localStorage.getItem('email');
    },
    userFormatted() {
      // console.log(`prueba: ${this.user}`);
      // input: nombre.apellido@usach.cl o bien nombre@usach.cl
      // output: Nombre

      const names = this.user.split('@')[0];
      const nombre = names.split('.')[0];

      // Retornar solo el nombre independiente si existe o no el apellido con la primera letra mayuscula
      return nombre.charAt(0).toUpperCase() + nombre.slice(1);
    },
    userProfilePhoto()
    {
      return this.$store.state.defaultAvatar;
    }
  },
  methods: {
    isFile(content) {
      return content.startsWith('data:'); // Simple chequeo para determinar si es una imagen
    }
  },
  created() {
    console.log('Mensaje: ', this.message);
    console.log('Usuario: ', this.user);
    console.log('Usuario actual: ', this.email);
  }
}
</script>

<style scoped>
.mainn, .mainn2 {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}

.mainn2 {
  flex-direction: row-reverse; /* Intercambia la posición de la foto y el mensaje */
}

.profile-photo, .profile-photo-img {
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  border-radius: 50%;
  margin-right: 10px;
}

.text-message {
  background-color: #323f48;
  color: white;
  padding: 10px;
  border-radius: 10px;
  word-wrap: break-word; /* Asegura que las palabras largas se dividan en varias líneas */
  word-break: break-word; /* Rompe palabras largas si es necesario */
  white-space: normal; /* Permite que el texto ocupe varias líneas */
  max-width: calc(100% - 60px); /* Limita el ancho del globo de mensaje */
  display: flex;
  justify-content: flex-start; /* Alinear el contenido a la izquierda */
  align-items: center;
  flex-wrap: wrap; /* Ajustar el contenido (texto/imagen) */
}

.text-message img {
  max-width: 100%;
  height: auto; /* Ajustar la altura de la imagen automáticamente */
  object-fit: contain; /* Asegura que la imagen mantenga su proporción */
  border-radius: 10px;
}

</style>